module.exports = __webpack_public_path__ + "static/img/day1.e425eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/day1.jpg
// module id = e9Ak
// module chunks = 0